import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxCaptchaModule } from 'ngx-captcha';
import { BrowserModule } from '@angular/platform-browser';

import { APP_BASE_HREF } from '@angular/common';
import { TabViewModule } from 'primeng/tabview';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
// prime import
import { PrimeNgModule } from './../primeng.module';
import { AdminComponent } from './admin/admin.component';
import { HomeComponent } from './views/home/home.component';
import { AdminLayoutComponent } from './admin/layout/admin-layout/admin-layout.component';
import { SidenavComponent } from './layout/sidenav/sidenav.component';
import { NavComponent } from './layout/nav/nav.component';
import { HomeSearchbarComponent } from './views/home/home-searchbar/home-searchbar.component';
import { HomeRecentComponent } from './views/home/home-recent/home-recent.component';
import { LoginComponent } from './views/login/login.component';
import { HomeEntitiesComponent } from './views/home/home-entities/home-entities.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HomeOtherpagesComponent } from './views/home/home-otherpages/home-otherpages.component';
import { CategoryComponent } from './views/category/category.component';
import { CategorySearchbarComponent } from './views/category/category-searchbar/category-searchbar.component';
import { CategoryOusComponent } from './views/category/category-ous/category-ous.component';
import { ListOusComponent } from './views/category/list-ous/list-ous.component';
import { DataViewComponent } from './views/category/data-view/data-view.component';
import { SafeHTMLPipe } from './misc/pipes/safe-html.pipe';
import { ImgOrIconDirective } from './misc/directive/img-or-icon.directive';
import { OrganizationUnitsComponent } from './admin/views/organization-units/organization-units.component';
import { HeaderComponent } from './admin/layout/header/header.component';
import { AddUnitComponent } from './admin/views/organization-units/add-unit/add-unit.component';
import { TableComponent } from './misc/component/table/table.component';
import { FormComponent } from './misc/component/form/form.component';
import { DynamicFormComponent } from './misc/component/dynamic-form/dynamic-form.component';
import { DynamicFormQuestionComponent } from './misc/component/dynamic-form/dynamic-form-question.component';
import { CategoriesComponent } from './admin/views/organization-units/categories/categories.component';
import { TypesComponent } from './admin/views/organization-units/types/types.component';
import { LocationsComponent } from './admin/views/organization-units/locations/locations.component';
import { SignupComponent } from './views/signup/signup.component';
import { ChangePasswordComponent } from './views/change-password/change-password.component';
import { UserMmanagementComponent } from './admin/views/user-mmanagement/user-mmanagement.component';
import { SignupFormComponent } from './views/signup/signup-form/signup-form.component';
import { CreateUserComponent } from './admin/views/user-mmanagement/create-user/create-user.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { RoleManagementComponent } from './admin/views/roles/role-management/role-management.component';
import { PositionComponent } from './admin/views/roles/position/position.component';
import { PermissionsComponent } from './admin/views/roles/permissions/permissions.component';
import { RoleInterfaceComponent } from './admin/views/roles/role-interface/role-interface.component';
import { SkelitionsComponent } from './admin/layout/skelitions/skelitions.component';

import { DataComponent } from './admin/views/data/data.component';
import { AddComponent } from './admin/views/data/add/add.component';
import { BulkComponent } from './admin/views/data/bulk/bulk.component';
import { NoDataComponent } from './no-data/no-data.component';
import { DataTypesComponent } from './admin/views/data/data-types/data-types.component';
import { DataTemplatesComponent } from './admin/views/data/data-templates/data-templates.component';
import { DataFieldsComponent } from './admin/views/data/data-fields/data-fields.component';
import { DataFieldTypesComponent } from './admin/views/data/data-field-types/data-field-types.component';
import { ActivateAccountComponent } from './views/login/activate-account/activate-account.component';
import { OnlineUsersComponent } from './admin/views/user-mmanagement/online-users/online-users.component';
import { UserDetailModelComponent } from './admin/views/user-mmanagement/online-users/user-detail-model/user-detail-model.component';
import { ContentUpdatePageComponent } from './admin/views/data/content-update-page/content-update-page.component';
import { ViewComponent } from './admin/views/knowledge_library/view/view.component';
import { KLibraryAdminComponent } from './admin/views/knowledge_library/admin/klibrary_admin.component';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { KCategoryComponent } from './admin/views/knowledge_library/k-category/k-category.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { CreatePermissionComponent } from './admin/views/roles/permissions/create-permission/create-permission.component';
import { TreeTableModule } from 'primeng/treetable';
import { UserProfileComponent } from './views/user-profile/user-profile.component';
import { CommentsComponent } from './admin/views/comments/comments.component';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { SearchResultComponent } from './views/category/search-result/search-result.component';
import { HighlightSearch } from 'src/app/services/highlight-text.pipe';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TrainingRequestComponent } from './admin/views/training/training-request/training-request.component';
import { TrainingTypeComponent } from './admin/views/training/training-type/training-type.component';
import { ViewTrainingRequestsComponent } from './admin/views/training/view-training-requests/view-training-requests.component';
import { CreateTrainingFormComponent } from './admin/views/training/create-training-form/create-training-form.component';
import { SurveyComponent } from './admin/views/survey/survey.component';
import { SurveyTypeComponent } from './admin/views/survey/survey-type/survey-type.component';
import { AddQuestionComponent } from './admin/views/survey/add-question/add-question.component';
import { ViewTrainingDetailsComponent } from './admin/views/training/view-training-details/view-training-details.component';
import { ViewCourseComponent } from './admin/course/view-course/view-course.component';
import { CreateCourseComponent } from './admin/course/create-course/create-course.component';
import { ViewCourseDetailsComponent } from './admin/course/view-course-details/view-course-details.component';
import { AssignUsersComponent } from './assign-users/assign-users.component';
import { UnifiedTriningReqComponent } from './admin/views/training/unified-trining-req/unified-trining-req.component';
import { SelectServiceComponent } from './admin/views/data/add/select-service/select-service.component';
import { NoInputSpaceDirective } from './misc/directive/no-input-space.directive';
import { NotificationComponent } from './notification/notification.component';
import { ChipsModule } from 'primeng/chips';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { AddCategoryComponent } from './admin/views/training/add-category/add-category.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ShowDetailComponent } from './admin/course/show-detail/show-detail.component';
import { AdvanceSearchComponent } from './views/category/advance-search/advance-search.component';
import { NgxAngularQueryBuilderModule } from 'ngx-angular-query-builder';
import { NgxPrintModule } from 'ngx-print';
import { BulkviewComponent } from './admin/views/data/bulk/bulkview/bulkview.component';
import { DashboardsComponent } from './admin/views/dashboards/dashboards.component';
import { LinegraphComponent } from './admin/views/dashboards/linegraph/linegraph.component';
import { BarchartComponent } from './admin/views/dashboards/barchart/barchart.component';
import { PiechartComponent } from './admin/views/dashboards/piechart/piechart.component';
import { AddnewdashboardComponent } from './admin/views/dashboards/addnewdashboard/addnewdashboard.component';
import { EditComponent } from './admin/views/dashboards/addnewdashboard/edit/edit.component';
import { StackedbarchartComponent } from './admin/views/dashboards/stackedbarchart/stackedbarchart.component';
import { TreechartComponent } from './admin/views/dashboards/treechart/treechart.component';
import { BubblechartComponent } from './admin/views/dashboards/bubblechart/bubblechart.component';
import { TreeDistributionComponent } from './admin/views/dashboards/tree-distribution/tree-distribution.component';
import { TreeMapComponent } from './admin/views/dashboards/tree-map/tree-map.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MultilinegraphComponent } from './admin/views/dashboards/multilinegraph/multilinegraph.component';
import { SearchViewComponent } from './views/category/search-view/search-view.component';

import { ListServicesComponent } from './views/category/list-services/list-services.component';
import { PageHeadingComponent } from './views/category/list-services/page-heading/page-heading.component';
import { ServicesViewComponent } from './views/category/list-services/services-view/services-view.component';
import { SingleDataViewComponent } from './views/single-data-view/single-data-view.component';
import { EservicepanelviewComponent } from './views/single-data-view/eservicepanelview/eservicepanelview.component';
import { TaskDetailViewComponent } from './admin/views/training/task-detail-view/task-detail-view.component';
import { TrainingUsersDetailComponent } from './admin/course/training-users-detail/training-users-detail.component';
import { TranslatorPipe } from './services/translator.pipe';
import { UserSurveyResultComponent } from './admin/views/survey/user-survey-result/user-survey-result.component';
import { SurveyAttendanceComponent } from './admin/views/survey/survey-attendance/survey-attendance.component';
import { QuestionTemplateComponent } from './admin/views/survey/question-template/question-template.component';
import { CompanyComponent } from './admin/views/company/company.component';
import { AddExternalUserComponent } from './admin/views/company/add-external-user/add-external-user.component';
import { AddExternalCoordinatorComponent } from './admin/views/company/add-external-coordinator/add-external-coordinator.component';
import { CoordinatorViewComponent } from './admin/views/company/coordinator-view/coordinator-view.component';
import { ViewTrainersComponent } from './admin/views/company/view-trainers/view-trainers.component';

import { YouTubePlayerModule } from '@angular/youtube-player';
import { NewBranchTrainingRequestsComponent } from './admin/views/training/new-branch-training-requests/new-branch-training-requests.component';
import { RadioButtonModule } from 'primeng/radiobutton';

import { SurveyTagsManagementComponent } from './admin/views/survey/survey-tags-management/survey-tags-management.component';
import { AssessmentComponent } from './admin/views/assessment/assessment.component';

import { SkillTrainingRequestsComponent } from './admin/views/training/skill-training-requests/skill-training-requests.component';
import { ReCreateComponent } from './admin/views/training/task-detail-view/re-create/re-create.component';
import { QuestionBankComponent } from './admin/views/assessment/question-bank/question-bank.component';
import { TrainingDashboardComponent } from './admin/views/training/training-dashboard/training-dashboard.component';
import { QuestionBankListComponent } from './admin/views/assessment/question-bank-list/question-bank-list.component';
import { QuestionsEditComponent } from './admin/views/survey/add-question/questions-edit/questions-edit.component';
import { AllDataViewComponent } from './views/all-data-view/all-data-view.component';
import { AllDataViewHeaderComponent } from './views/all-data-view/all-data-view-header/all-data-view-header.component';
import { AllDataViewItemsComponent } from './views/all-data-view/all-data-view-items/all-data-view-items.component';
import { TrainingCalanderComponent } from './admin/views/training/training-calander/training-calander.component';
import { UserTableComponent } from './admin/views/survey/user-table/user-table.component';
import { AssessmentResultsComponent } from './admin/views/assessment/assessment-results/assessment-results.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddTrainingKlComponent } from './admin/views/training/add-training-kl/add-training-kl.component';
import { MysteryShopperComponent } from './mystery-shopper/mystery-shopper.component';

import { MsVendorComponent } from './admin/views/mystery-shopper/ms-vendor/ms-vendor.component';
import { MsResponsibleComponent } from './admin/views/mystery-shopper/ms-responsible/ms-responsible.component';
import { MsProjectComponent } from './admin/views/mystery-shopper/ms-project/ms-project.component';
import { AddProjectComponent } from './admin/views/mystery-shopper/ms-project/add-project/add-project.component';
import { MsMeasuringTypesComponent } from './admin/views/mystery-shopper/ms-measuring-types/ms-measuring-types.component';
import { MsFactorComponent } from './admin/views/mystery-shopper/ms-factor/ms-factor.component';
import { MsCriteriaComponent } from './admin/views/mystery-shopper/ms-criteria/ms-criteria.component';
import { MsDashboardComponent } from './admin/views/mystery-shopper/ms-dashboard/ms-dashboard.component';
import { AssignWeightsComponent } from './admin/views/mystery-shopper/assign-weights/assign-weights.component';
import { ProjectDetailsCardComponent } from './admin/views/mystery-shopper/project-details-card/project-details-card.component';
import { ProjectStepComponent } from './admin/views/mystery-shopper/project-step/project-step.component';
import { MsCalenderComponent } from './admin/views/mystery-shopper/ms-calender/ms-calender.component';
import { MsEvaluationComponent } from './admin/views/mystery-shopper/ms-evaluation/ms-evaluation.component';
import { ProjectListComponent } from './admin/views/mystery-shopper/project-list/project-list.component';
import { MsFactorDashboardComponent } from './admin/views/mystery-shopper/ms-factor-dashboard/ms-factor-dashboard.component';
import { MsFactorReportsComponent } from './admin/views/mystery-shopper/ms-factor-reports/ms-factor-reports.component';
import { FactorForwardingComponent } from './admin/views/mystery-shopper/ms-factor/factor-forwarding/factor-forwarding.component';
import { MsSessionComponent } from './admin/views/mystery-shopper/ms-session/ms-session.component';
import { KlApprovalComponent } from './admin/views/training/kl-approval/kl-approval.component';
import { TrainingPageComponent } from './training-page/training-page.component';
import { AssessmentTopicsComponent } from './admin/views/assessment/assessment-topics/assessment-topics.component';
import { ContentViewComponent } from './training-page/content-view/content-view.component';
import { MainViewComponent } from './training-page/main-view/main-view.component';
import { FileUploadComponent } from './misc/component/common/file-upload/file-upload.component';
import { SessionPageComponent } from './training-page/session-page/session-page.component';
import { TrainingAssessmentComponent } from './training-page/training-assessment/training-assessment.component';
import { TrainingSurveyComponent } from './training-page/training-survey/training-survey.component';
import { BulkResultsComponent } from './admin/views/assessment/bulk-results/bulk-results.component';
import { AssessmentResultModuleComponent } from './admin/views/assessment/assessment-result-module/assessment-result-module.component';
import { EditmissingComponent } from './views/login/editmissing/editmissing.component';
import { QRCodeModule } from 'angularx-qrcode';
import { CustomAlertComponent } from './admin/views/training/custom-alert/custom-alert.component';
import { ToastModule } from 'primeng/toast';
import { TrainingCertificateComponent } from './training-page/training-certificate/training-certificate.component';
import { SkilltrainingdashComponent } from './admin/views/training/training-dashboard/skilltrainingdash/skilltrainingdash.component';
import { OuInfoComponent } from './admin/views/dashboards/ou-info/ou-info.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { AssessmentCertificateComponent } from './admin/views/assessment/assessment-certificate/assessment-certificate.component';
import { DatatableComponent } from './admin/views/dashboards/datatable/datatable.component';
import { TrainingRatingComponent } from './admin/views/training/training-rating/training-rating.component';
import { RatingGraphComponent } from './admin/views/training/rating-graph/rating-graph.component';
import { InvestorControllerComponent } from './investor-controller/investor-controller.component';
import { TrainingResultsComponent } from './admin/views/training/training-results/training-results.component';
import { SignHistoryComponent } from './views/category/sign-history/sign-history.component';
import { TrainingProgramComponent } from './training-program/training-program.component';
import { AddTrainingProgramComponent } from './training-program/add-training-program/add-training-program.component';
import { UpdateDatesComponent } from './training-program/update-dates/update-dates.component';
import { TrainingTimelineComponent } from './training-timeline/training-timeline.component';
import { TrainingProgramViewComponent } from './training-program-view/training-program-view.component';
import { TrainingUserManagementComponent } from './admin/views/training/training-user-management/training-user-management.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TrainingImpactSettingsComponent } from './training-page/training-impact-settings/training-impact-settings.component';
import { ManagerImpactTaskComponent } from './training-page/manager-impact-task/manager-impact-task.component';
import { TrainerImpactTasksComponent } from './training-page/trainer-impact-tasks/trainer-impact-tasks.component';
import { ProgramUserManagmentComponent } from './admin/views/training/program-user-managment/program-user-managment.component';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from 'environment';
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
import { TrainingRevampComponent } from './views/home/training-revamp/training-revamp.component';
import { FilterButtonSuffix } from './misc/directive/clear-button-suffix.directive';
import { RedirectSurveyComponent } from './misc/redirect-survey-component/redirect-survey-component.component';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';
import { AnnouncementComponent } from './admin/views/announcement/announcement.component';
import { AnnouncementResultsComponent } from './admin/views/announcement/announcement-results/announcement-results.component';
import { ReminderModalComponent } from './reminder-modal/reminder-modal.component';
import { PreodicReportsComponent } from './preodic-reports/preodic-reports.component';
import { CreatePeriodicReportsComponent } from './preodic-reports/create-periodic-reports/create-periodic-reports.component';
import { PopupviewQuestionsComponent } from './views/home/popupview-questions/popupview-questions.component';
import { PopupTutorialComponent } from './views/home/popup-tutorial/popup-tutorial.component';

@NgModule({
  declarations: [
    ProjectDetailsCardComponent,
    TrainerImpactTasksComponent,
    TrainingPageComponent,
    SessionPageComponent,
    ContentViewComponent,
    TrainingAssessmentComponent,
    TrainingSurveyComponent,
    MainViewComponent,
    AssessmentTopicsComponent,
    MsSessionComponent,
    FactorForwardingComponent,
    MsFactorDashboardComponent,
    MsFactorReportsComponent,
    ProjectStepComponent,
    BulkResultsComponent,
    ProjectListComponent,
    MysteryShopperComponent,
    AppComponent,
    AdminComponent,
    ViewComponent,
    KLibraryAdminComponent,
    HomeComponent,
    AdminLayoutComponent,
    SidenavComponent,
    NavComponent,
    HomeSearchbarComponent,
    HomeRecentComponent,
    SelectServiceComponent,
    LoginComponent,
    HomeEntitiesComponent,
    FooterComponent,
    HomeOtherpagesComponent,
    CategoryComponent,
    CategorySearchbarComponent,
    CategoryOusComponent,
    ListOusComponent,
    DataViewComponent,
    SafeHTMLPipe,
    ImgOrIconDirective,
    OrganizationUnitsComponent,
    HeaderComponent,
    AddUnitComponent,
    TableComponent,
    QuestionsEditComponent,
    UserTableComponent,
    FormComponent,
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    CategoriesComponent,
    TypesComponent,
    LocationsComponent,
    SignupComponent,
    ChangePasswordComponent,
    UserMmanagementComponent,
    SignupFormComponent,
    HighlightSearch,
    CreateUserComponent,
    RoleManagementComponent,
    PositionComponent,
    PermissionsComponent,
    RoleInterfaceComponent,
    SkelitionsComponent,
    DataComponent,
    AddComponent,
    BulkComponent,
    NoDataComponent,
    DataTypesComponent,
    DataTemplatesComponent,
    DataFieldsComponent,
    DataFieldTypesComponent,
    ActivateAccountComponent,
    OnlineUsersComponent,
    UserDetailModelComponent,
    ContentUpdatePageComponent,
    KCategoryComponent,
    CreatePermissionComponent,
    UserProfileComponent,
    CommentsComponent,
    SearchResultComponent,
    TrainingRequestComponent,
    TrainingTypeComponent,
    ViewTrainingRequestsComponent,
    CreateTrainingFormComponent,
    SurveyComponent,
    SurveyTypeComponent,
    AddQuestionComponent,
    ViewTrainingDetailsComponent,
    ViewCourseComponent,
    CreateCourseComponent,
    ViewCourseDetailsComponent,
    AssignUsersComponent,
    UnifiedTriningReqComponent,
    NoInputSpaceDirective,
    FilterButtonSuffix,
    NotificationComponent,
    AddCategoryComponent,
    ShowDetailComponent,
    AdvanceSearchComponent,
    BulkviewComponent,
    DashboardsComponent,
    LinegraphComponent,
    BarchartComponent,
    PiechartComponent,
    AddnewdashboardComponent,
    EditComponent,
    StackedbarchartComponent,
    TreechartComponent,
    BubblechartComponent,
    TreeDistributionComponent,
    TreeMapComponent,
    MultilinegraphComponent,
    SearchViewComponent,
    ListServicesComponent,
    PageHeadingComponent,
    ServicesViewComponent,
    SingleDataViewComponent,
    EservicepanelviewComponent,
    TaskDetailViewComponent,
    TrainingUsersDetailComponent,
    TranslatorPipe,
    UserSurveyResultComponent,
    SurveyAttendanceComponent,
    QuestionTemplateComponent,
    CompanyComponent,
    AddExternalUserComponent,
    AddExternalCoordinatorComponent,
    CoordinatorViewComponent,
    ViewTrainersComponent,
    NewBranchTrainingRequestsComponent,
    SurveyTagsManagementComponent,
    AssessmentComponent,
    SkillTrainingRequestsComponent,
    ReCreateComponent,
    QuestionBankComponent,
    TrainingDashboardComponent,
    QuestionBankListComponent,
    AllDataViewComponent,
    AllDataViewHeaderComponent,
    AllDataViewItemsComponent,
    TrainingCalanderComponent,
    AssessmentResultsComponent,
    AddTrainingKlComponent,
    MsResponsibleComponent,
    MsProjectComponent,
    AddProjectComponent,
    MsMeasuringTypesComponent,
    MsFactorComponent,
    MsCriteriaComponent,
    MsDashboardComponent,
    MsVendorComponent,
    AssignWeightsComponent,
    MsCalenderComponent,
    MsEvaluationComponent,
    KlApprovalComponent,
    TrainingPageComponent,
    BulkResultsComponent,
    FileUploadComponent,
    AssessmentResultModuleComponent,
    EditmissingComponent,
    CustomAlertComponent,
    TrainingCertificateComponent,
    SkilltrainingdashComponent,
    OuInfoComponent,
    AssessmentCertificateComponent,
    DatatableComponent,
    TrainingRatingComponent,
    RatingGraphComponent,
    InvestorControllerComponent,
    TrainingResultsComponent,
    SignHistoryComponent,
    TrainingProgramComponent,
    AddTrainingProgramComponent,
    UpdateDatesComponent,
    TrainingTimelineComponent,
    TrainingProgramViewComponent,
    TrainingUserManagementComponent,
    TrainingImpactSettingsComponent,
    ManagerImpactTaskComponent,
    TrainerImpactTasksComponent,
    ProgramUserManagmentComponent,
    TrainingRevampComponent,
    RedirectSurveyComponent,
    AnnouncementComponent,
    AnnouncementResultsComponent,
    RedirectSurveyComponent,
    ReminderModalComponent,
    PreodicReportsComponent,
    CreatePeriodicReportsComponent,
    PopupviewQuestionsComponent,
    PopupTutorialComponent
  ],
  imports: [
    QRCodeModule,
    DragDropModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxPrintModule,
    ChipsModule,
    NgxCaptchaModule,
    TreeTableModule,
    NgxDocViewerModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    CalendarModule,
    CardModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    PrimeNgModule,
    HttpClientModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    TieredMenuModule,
    TabViewModule,
    SelectButtonModule,
    NgxAngularQueryBuilderModule,
    NgApexchartsModule,
    RadioButtonModule,
    YouTubePlayerModule,
    ToastModule,
    NgOtpInputModule,
    AutoCompleteModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    TreeModule,
    TreeSelectModule
  ],
  providers: [
    MessageService,
    ConfirmationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaSiteKey,
      } as RecaptchaSettings,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
